import React, {Component} from 'react';
import {Button, FormControl} from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.sendEmail = this.sendEmail.bind(this);
        this.formChange = this.formChange.bind(this);
        this.state = {
            emailComponents: {
                date: '',
                patient_name: '',
                acc_name: '',
                acc_email: '',
                job_no: '',
                re_sph: '',
                re_cyl: '',
                re_axis: '',
                re_add: '',
                re_prism_h: '',
                re_prism_v: '',
                re_mono_pd: '',
                le_sph: '',
                le_cyl: '',
                le_axis: '',
                le_add: '',
                le_prism_h: '',
                le_prism_v: '',
                le_mono_pd: '',
                binoc_pd: '',
                lens_index: '',
                lens_material: '',
                lens_type: '',
                lens_desc: '',
                mfh: '',
                coating: '',
                frame_details: '',
                rheight: '',
                lheight: '',
                seg_size: '',
                tint: '',
                lens_comments: '',
                job_comments: '',
                addons: {
                    addon_sample: '',
                    addon_sample2: ''
                }
            },
            placeholders: {
                date: 'Date',
                patient_name: 'Patient name',
                acc_name: 'Acc name',
                acc_email: 'Acc email',
                job_no: 'Job no',
                re_sph: 'SPH',
                re_cyl: 'CYL',
                re_axis: 'AXIS',
                re_add: 'ADD',
                re_prism_h: 'Prism H',
                re_prism_v: 'Prism V',
                re_mono_pd: 'Mono PD',
                le_sph: 'SPH',
                le_cyl: 'CYL',
                le_axis: 'AXIS',
                le_add: 'ADD',
                le_prism_h: 'Prism H',
                le_prism_v: 'Prism V',
                le_mono_pd: 'Mono PD',
                binoc_pd: 'Binoc PD',
                lens_index: 'Lens Index',
                lens_material: 'Lens Material',
                lens_type: 'Lens Type',
                lens_desc: 'Lens Desc',
                mfh: 'MFH',
                coating: 'Coating',
                frame_details: 'Frame details',
                rheight: 'Right height',
                lheight: 'Left height',
                seg_size: 'Seg size',
                tint: 'Tint',
                lens_comments: 'Lens comments',
                job_comments: 'Job comments',
                addons: {
                    addon_sample: '',
                    addon_sample2: ''
                }
            },
            errors: {},
            emailSent: false
        }
    }

    componentDidMount() {
        var stateCopy = JSON.parse(JSON.stringify(this.state));
        var search = window.location.search.substring(1);
        var json = search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
            function (key, value) {
                return key === "" ? value : decodeURIComponent(value)
            }) : {};
        stateCopy.emailComponents.addons = {};
        for (var property in json) {
            var modifiedPropertyName = property.toLowerCase().replace(/\+/g, '_');
            if (modifiedPropertyName.indexOf('addon') > -1) {
                stateCopy.emailComponents.addons[modifiedPropertyName] = json[property];
            } else if (modifiedPropertyName.indexOf('corridor') > -1) {
                stateCopy.emailComponents['mfh'] = parseInt(json[property]) + 2;
            } else {
                stateCopy.emailComponents[modifiedPropertyName] = json[property];
            }
        }
        this.setState(stateCopy);
    }

    formChange(formElement, event) {
        var {emailComponents} = this.state;
        if (formElement.indexOf('addon') > -1) {
            emailComponents.addons[formElement] = event.target.value;
        } else {
            emailComponents[formElement] = event.target.value;
        }
        this.setState({
            emailComponents: emailComponents
        });
    }

    selectOption(prop, e) {
        var emailComponents = JSON.parse(JSON.stringify(this.state.emailComponents));
        if (typeof e === 'object' && e) {
            if (typeof e.target === 'object') {
                emailComponents[prop] = e.target.value;
            } else {
                emailComponents[prop] = e.value;
            }
        } else {
            emailComponents[prop] = e;
        }
        this.setState({emailComponents: emailComponents});
    }

    sendEmail() {
        // let querystring = 'http://orders.hastingsopticalsupplies.com.au/api/send_email/';
        let querystring = 'https://lk2z28ig89.execute-api.ap-southeast-2.amazonaws.com/production/api/send_email/';

        let empties = {};

        if (
            typeof empties.date === 'undefined' && typeof empties.patient_name === 'undefined' &&
            typeof empties.acc_name === 'undefined' && typeof empties.job_no === 'undefined' &&
            typeof empties.frame_details === 'undefined' && typeof empties.acc_email === 'undefined'
        ) {

            this.setState({errors: {}});

            fetch(querystring, {
                method: 'post',
                body: JSON.stringify(this.state.emailComponents)
            }).then((response) => {
                this.setState({emailSent: true});
            }).then((json) => {
            });

        } else {
            this.setState({errors: empties})
        }
    }

    render() {
        const {emailComponents, placeholders, errors, emailSent} = this.state;

        var addonNames = [];
        var addonInputs = [];
        for (var name in emailComponents.addons) {
            addonNames.push(<p key={name} style={{textAlign: 'right'}}>{name.replace('addon_', '')}</p>);
            addonInputs.push(<FormControl key={'input-' + name} value={emailComponents.addons[name]}
                                          onChange={this.formChange.bind(this, name)} style={{marginTop: '10px'}}
                                          className="horizontal-input" type="text"/>);
        }
        var options = [
            {value: 'clear', label: 'Clear'},
            {value: 'neochromes', label: 'NeoChromes'},
            {value: 'trans-7', label: 'Trans 7'},
            {value: 'xtractive', label: 'XtrActive'},
            {value: 'vantage', label: 'Vantage'},
            {value: 'nupolar-grey-85', label: 'Nupolar Grey 85%'},
            {value: 'nupolar-grey-65', label: 'Nupolar Grey 65%'},
            {value: 'nupolar-brown', label: 'Nupolar Brown'},
            {value: 'nupolar-green', label: 'Nupolar Green'},
            {value: 'drivewear', label: 'DriveWear'},
            {value: 'other-see-comments', label: 'Other (see comments)'},
        ];

        console.log(emailComponents)
        return (
            <div className="App">
                <div className="App-header">
                    <img src="site-logo.png" className="logo"/>
                    <h1 className="noPrint">Online Order Form</h1>
                    <center><p>Instructions: Review order details, select Frame Details then click Send Order.</p>
                    </center>
                </div>
                <div className="App-body">
                    {emailSent ?
                        <div>
                            <h4>New Order Created</h4>
                            <p>Your order has been sent to {emailComponents['acc_email']}.</p>
                            <p>Please contact HOS for any queries.</p>
                        </div>
                        :
                        <div>
                            <div>
                                <div className="row">
                                    <div className="input-columns column-0">
                                        <p><strong>Date</strong></p>
                                        <br/><br/>
                                        <p style={{marginTop: '60px'}}><strong>RE</strong></p>
                                        <br/><br/>
                                        <p style={{marginTop: '6px'}}><strong>LE</strong></p>
                                    </div>
                                    <div className="input-columns">
                                        <FormControl tabIndex={1}
                                                     className={"horizontal-input " + (typeof errors.date !== 'undefined' ? 'error-input' : '')}
                                                     placeholder={placeholders.date} value={emailComponents.date}
                                                     onChange={this.formChange.bind(this, 'date')} type="text"/>
                                        <p style={{marginTop: '75px'}} className="control-label">SPH</p>
                                        <FormControl tabIndex={6} className="horizontal-input"
                                                     placeholder={placeholders.re_sph} value={emailComponents.re_sph}
                                                     onChange={this.formChange.bind(this, 're_sph')} type="text"/>
                                        <br/>
                                        <p className="control-label">SPH</p>
                                        <FormControl tabIndex={13} className="horizontal-input"
                                                     placeholder={placeholders.le_sph} value={emailComponents.le_sph}
                                                     onChange={this.formChange.bind(this, 'le_sph')} type="text"/>
                                        <br/>
                                        <p className="control-label">Lens Index</p>
                                        <FormControl tabIndex={21} className="horizontal-input"
                                                     placeholder={placeholders.lens_index}
                                                     value={emailComponents.lens_index}
                                                     onChange={this.formChange.bind(this, 'lens_index')} type="text"/>
                                        <br/>
                                        <p className="control-label">Frame Details</p>
                                        <FormControl tabIndex={28}
                                                     className={(typeof errors.frame_details !== 'undefined' ? 'error-input' : '')}
                                                     componentClass="select"
                                                     onChange={this.selectOption.bind(this, 'frame_details')}
                                                     value={emailComponents.frame_details}>
                                            <option value="select">(none selected)</option>
                                            <option value="Supply Uncut">Supply Uncut</option>
                                            <option value="Trace File Sent">Trace File Sent</option>
                                            <option value="Frame to be sent">Frame to be sent</option>
                                            <option value="See Job Comments">See Job Comments</option>
                                        </FormControl>
                                    </div>
                                    <div className="input-columns">
                                        <p style={{textAlign: 'right'}}><strong>Patient Name</strong></p>
                                        <p style={{marginTop: '66px'}} className="control-label">CYL</p>
                                        <FormControl tabIndex={7} className="horizontal-input"
                                                     placeholder={placeholders.re_cyl} value={emailComponents.re_cyl}
                                                     onChange={this.formChange.bind(this, 're_cyl')} type="text"/>
                                        <br/>
                                        <p className="control-label">CYL</p>
                                        <FormControl tabIndex={14} className="horizontal-input"
                                                     placeholder={placeholders.le_cyl} value={emailComponents.le_cyl}
                                                     onChange={this.formChange.bind(this, 'le_cyl')} type="text"/>
                                        <br/>
                                        <p className="control-label">Lens Material</p>
                                        <Select
                                            tabIndex={22}
                                            name="lens-material"
                                            clearable={false}
                                            noResultsText={false}
                                            onBlurResetsInput={false}
                                            onCloseResetsInput={false}
                                            value={{
                                                label: emailComponents.lens_material,
                                                value: emailComponents.lens_material
                                            }}
                                            placeholder={placeholders.lens_material}
                                            options={options}
                                            onInputChange={this.selectOption.bind(this, 'lens_material')}
                                            onChange={this.selectOption.bind(this, 'lens_material')}
                                        />
                                    </div>
                                    <div className="input-columns">
                                        <FormControl tabIndex={2}
                                                     className={"horizontal-input " + (typeof errors.patient_name !== 'undefined' ? 'error-input' : '')}
                                                     placeholder={placeholders.patient_name}
                                                     value={emailComponents.patient_name}
                                                     onChange={this.formChange.bind(this, 'patient_name')} type="text"/>
                                        <p style={{marginTop: '75px'}} className="control-label">AXIS</p>
                                        <FormControl tabIndex={8} className="horizontal-input"
                                                     placeholder={placeholders.re_axis} value={emailComponents.re_axis}
                                                     onChange={this.formChange.bind(this, 're_axis')} type="text"/>
                                        <br/>
                                        <p className="control-label">AXIS</p>
                                        <FormControl tabIndex={15} className="horizontal-input"
                                                     placeholder={placeholders.le_axis} value={emailComponents.le_axis}
                                                     onChange={this.formChange.bind(this, 'le_axis')} type="text"/>
                                        <br/>
                                        <p className="control-label">Lens Type</p>
                                        <FormControl tabIndex={23} className="horizontal-input" componentClass="select"
                                                     onChange={this.selectOption.bind(this, 'lens_type')}
                                                     placeholder="select" value={emailComponents.lens_type}>
                                            <option value="select">(none selected)</option>
                                            <option value="s/v distance">S/V Distance</option>
                                            <option value="s/v near">S/V Near</option>
                                            <option value="bifocal">Bifocal</option>
                                            <option value="trifocal">Trifocal</option>
                                            <option value="progressive">Progressive</option>
                                            <option value="progressive near">Progressive Near</option>
                                            <option value="intermediate">Intermediate</option>
                                            <option value="other see lens comments">Other (see Lens Comments)</option>
                                        </FormControl>
                                        <br/>
                                        <p className="control-label">Right height</p>
                                        <FormControl tabIndex={30} className="horizontal-input"
                                                     placeholder={placeholders.rheight} value={emailComponents.rheight}
                                                     onChange={this.formChange.bind(this, 'rheight')} type="text"/>
                                    </div>
                                    <div className="input-columns">
                                        <p style={{textAlign: 'right'}}><strong>Acc Name</strong></p>
                                        <br/>
                                        <p style={{textAlign: 'right', marginTop: '-7px'}}><strong>Acc Email</strong>
                                        </p>
                                        <p style={{marginTop: '10px'}} className="control-label">ADD</p>
                                        <FormControl tabIndex={9} className="horizontal-input"
                                                     placeholder={placeholders.re_add} value={emailComponents.re_add}
                                                     onChange={this.formChange.bind(this, 're_add')} type="text"/>
                                        <br/>
                                        <p className="control-label">ADD</p>
                                        <FormControl tabIndex={16} className="horizontal-input"
                                                     placeholder={placeholders.le_add} value={emailComponents.le_add}
                                                     onChange={this.formChange.bind(this, 'le_add')} type="text"/>
                                        <br/>
                                        <p className="control-label">Lens Desc.</p>
                                        <FormControl tabIndex={24} className="horizontal-input"
                                                     placeholder={placeholders.lens_desc}
                                                     value={emailComponents.lens_desc}
                                                     onChange={this.formChange.bind(this, 'lens_desc')} type="text"/>
                                        <br/>
                                        <p className="control-label">Left height</p>
                                        <FormControl tabIndex={29} className="horizontal-input"
                                                     placeholder={placeholders.lheight} value={emailComponents.lheight}
                                                     onChange={this.formChange.bind(this, 'lheight')} type="text"/>
                                    </div>
                                    <div className="input-columns">
                                        <FormControl tabIndex={3}
                                                     className={"horizontal-input " + (typeof errors.acc_name !== 'undefined' ? 'error-input' : '')}
                                                     placeholder={placeholders.acc_name}
                                                     value={emailComponents.acc_name}
                                                     onChange={this.formChange.bind(this, 'acc_name')} type="text"/>
                                        <br/>
                                        <FormControl tabIndex={4}
                                                     className={"horizontal-input " + (typeof errors.acc_email !== 'undefined' ? 'error-input' : '')}
                                                     placeholder={placeholders.acc_email}
                                                     value={emailComponents.acc_email}
                                                     onChange={this.formChange.bind(this, 'acc_email')} type="text"/>
                                        <br/>
                                        <p className="control-label">Prism H</p>
                                        <FormControl tabIndex={10} className="horizontal-input"
                                                     placeholder={placeholders.re_prism_h}
                                                     value={emailComponents.re_prism_h}
                                                     onChange={this.formChange.bind(this, 're_prism_h')} type="text"/>
                                        <br/>
                                        <p className="control-label">Prism H</p>
                                        <FormControl tabIndex={17} className="horizontal-input"
                                                     placeholder={placeholders.le_prism_h}
                                                     value={emailComponents.le_prism_h}
                                                     onChange={this.formChange.bind(this, 'le_prism_h')} type="text"/>
                                        <p style={{marginTop: '105px'}} className="control-label">Seg size</p>
                                        <FormControl tabIndex={31} className="horizontal-input"
                                                     placeholder={placeholders.seg_size}
                                                     value={emailComponents.seg_size}
                                                     onChange={this.formChange.bind(this, 'seg_size')} type="text"/>
                                    </div>
                                    <div className="input-columns">
                                        <p style={{textAlign: 'right'}}><strong>JOB No.</strong></p>
                                        <p style={{marginTop: '65px'}} className="control-label">Prism V</p>
                                        <FormControl tabIndex={11} className="horizontal-input"
                                                     placeholder={placeholders.re_prism_v}
                                                     value={emailComponents.re_prism_v}
                                                     onChange={this.formChange.bind(this, 're_prism_v')} type="text"/>
                                        <br/>
                                        <p className="control-label">Prism V</p>
                                        <FormControl tabIndex={18} className="horizontal-input"
                                                     placeholder={placeholders.le_prism_v}
                                                     value={emailComponents.le_prism_v}
                                                     onChange={this.formChange.bind(this, 'le_prism_v')} type="text"/>
                                        <br/>
                                        <p className="control-label">MFH (Corr. Len + 2)</p>
                                        <FormControl tabIndex={25} className="horizontal-input"
                                                     placeholder={placeholders.mfh} value={emailComponents.mfh}
                                                     onChange={this.formChange.bind(this, 'mfh')} type="text"/>
                                    </div>
                                    <div className="input-columns">
                                        <FormControl tabIndex={5}
                                                     className={"horizontal-input " + (typeof errors.job_no !== 'undefined' ? 'error-input' : '')}
                                                     placeholder={placeholders.job_no} value={emailComponents.job_no}
                                                     onChange={this.formChange.bind(this, 'job_no')} type="text"/>
                                        <p style={{marginTop: '75px'}} className="control-label">Mono PD</p>
                                        <FormControl tabIndex={12} className="horizontal-input"
                                                     placeholder={placeholders.re_mono_pd}
                                                     value={emailComponents.re_mono_pd}
                                                     onChange={this.formChange.bind(this, 're_mono_pd')} type="text"/>
                                        <br/>
                                        <p className="control-label">Mono PD</p>
                                        <FormControl tabIndex={19} className="horizontal-input"
                                                     placeholder={placeholders.le_mono_pd}
                                                     value={emailComponents.le_mono_pd}
                                                     onChange={this.formChange.bind(this, 'le_mono_pd')} type="text"/>
                                        <br/>
                                        <p className="control-label">Coating</p>
                                        <FormControl tabIndex={26} className="horizontal-input"
                                                     placeholder={placeholders.coating} value={emailComponents.coating}
                                                     onChange={this.formChange.bind(this, 'coating')} type="text"/>
                                        <br/>
                                        <p className="control-label">Tint</p>
                                        <FormControl tabIndex={32} className="horizontal-input"
                                                     placeholder={placeholders.tint} value={emailComponents.tint}
                                                     onChange={this.formChange.bind(this, 'tint')} type="text"/>
                                    </div>
                                    <div className="input-columns">
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <p className="control-label">Binoc PD</p>
                                        <FormControl tabIndex={20} className="horizontal-input"
                                                     placeholder={placeholders.binoc_pd}
                                                     value={emailComponents.binoc_pd}
                                                     onChange={this.formChange.bind(this, 'binoc_pd')} type="text"/>
                                        <br/>
                                    </div>
                                </div>
                                <div className="input-columns column-2-0 row-2">
                                    <p style={{textAlign: 'right'}}>Lens Comments</p>
                                    <br/>
                                    <p style={{textAlign: 'right'}}>Job Comments</p>
                                    <br/>
                                    {addonNames}
                                </div>
                                <div className="input-columns column-2-1 row-2">
                                    <FormControl tabIndex={33} className="horizontal-input"
                                                 placeholder={placeholders.lens_comments}
                                                 value={emailComponents.lens_comments}
                                                 onChange={this.formChange.bind(this, 'lens_comments')} type="text"/>
                                    <br/>
                                    <FormControl tabIndex={34} style={{marginTop: '5px'}}
                                                 placeholder={placeholders.job_comments}
                                                 value={emailComponents.job_comments}
                                                 onChange={this.formChange.bind(this, 'job_comments')}
                                                 className="horizontal-input" type="text"/>
                                    <br/>
                                    {addonInputs}
                                </div>
                            </div>
                            <Button bsStyle="primary" bsSize="lg" onClick={this.sendEmail}>Send Order</Button>
                        </div>}
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js